import React from "react";

const WideRangeSection = () => {
  return (
    <div
      className="section-full py-3 site-bg-white twm-w-range-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">
        {/* TITLE START */}
        <div className="section-head center">
          <div className="twm-sm-title left">Velocity Cab Achievements</div>
          <h2 className="twm-large-title site-text-dark">
            Safe & Smooth Journeys
          </h2>
        </div>
        {/* TITLE END */}

        <div className="section-content">
          <div className="row twm-w-range-section">

            {/* Clients Served */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/rental.png" alt="Clients Served" />
                </div>
                <span className="counter">8500</span> <em className="symble">+</em>
                <h3 className="icon-content-info">Clients Served</h3>
              </div>
            </div>

            {/* Happy Customers */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/man.png" alt="Happy Customers" />
                </div>
                <span className="counter">6200</span> <em className="symble">+</em>
                <h3 className="icon-content-info">Happy Customers</h3>
              </div>
            </div>

            {/* Vehicles Available */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/car-insurance.png" alt="Vehicles Available" />
                </div>
                <span className="counter">350</span> <em className="symble">+</em>
                <h3 className="icon-content-info">Vehicles Available</h3>
              </div>
            </div>

            {/* Years of Experience */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/work-time.png" alt="Years of Experience" />
                </div>
                <span className="counter">10</span> <em className="symble">+</em>
                <h3 className="icon-content-info">Years of Experience</h3>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default WideRangeSection;